import { Fragment, ReactElement } from 'react';

export const Nocp = (): ReactElement => {
  return <Fragment></Fragment>;
};

Nocp.displayName = 'Empty component';
